import { Component } from '@angular/core';

@Component({
  selector: 'side-menu',
  imports: [],
  template: `
    <aside class="w-full">
      <div
        class="rounded-3xl border border-slate-200/70 bg-white/95 p-6 shadow-sm backdrop-blur"
      >
        <nav class="space-y-2 text-sm text-slate-600">
          <ng-content></ng-content>
        </nav>
      </div>
    </aside>
  `,
  styles: ``,
})
export class SideMenuComponent {}
